import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/core/base.component';
import { BookingService } from '../services/booking.service';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';
import { SessionService } from 'src/app/shared/services/session.service';
import { BookingList } from '../models/booking-list';
import { BookingListQueryFilter } from './booking-list-query-filter';
import { Sort } from '@angular/material/sort';
import { BookingStatusEnum } from 'src/app/shared/models/booking-status.enum';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { BookingRefundModalComponent } from '../modals/booking/booking-refund-modal/booking-refund-modal.component';
import { BookingRefund } from '../models/booking-refund';
import { BookingQuickviewModalComponent } from '../modals/booking/booking-quickview-modal/booking-quickview-modal.component';
import * as moment from 'moment-timezone';

@Component({
  selector: 'booking-list',
  templateUrl: './booking-list.component.html',
  styleUrl: './booking-list.component.scss',
  providers: [provideNativeDateAdapter()],
  standalone: false
})
export class BookingListComponent extends BaseComponent implements OnInit {
  public bookings: BookingList[] = [];
  @Input() filter: BookingListQueryFilter = new BookingListQueryFilter();
  public updateFilterEvent = new EventEmitter<any>();
  BookingStatus = BookingStatusEnum;
  userTimezone: string;

  constructor(sessionService: SessionService,
    stringHelpers: StringHelpers,
    private matDialog: MatDialog,
    private bookingService: BookingService
  ) {
    super(sessionService, stringHelpers);
  }

  ngOnInit(): void {
    this.filter.organizationId = this.sessionService.getUser().organizationId;
    this.filter.hasPaid = null;
    this.userTimezone = this.sessionService.getUser().timeZone;
    this.filter.fromDate = new Date(this.stringHelpers.normalizeDateTime(new Date()));

    this.displayedColumns = ['customerName', 'email', 'date', 'timeslot', 'status', 'confirmationNumber', 'hasPaid', 'totalPrice', 'actions'];
    this.getBookings();
  }

  getBookings() {
    this.isLoading = true;
    if (this.filter.toDate) {
      this.filter.toDate = new Date(this.stringHelpers.normalizeDateTime(this.filter.toDate));
    }

    this.bookingService.getAllByOrganization(this.filter).subscribe({
      next: (result: any) => {
        this.bookings = result.results;
        this.filter.totalCount = result.totalCount;
        this.updateFilterEvent.emit(result.results);
      },
      error: (error: any) => {
        console.error(error);
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  refund(booking: BookingList) {
    const dialogRef = this.matDialog.open(BookingRefundModalComponent, {
      width: '500px',
      height: 'auto',
    });

    dialogRef.componentInstance.bookingRefund = BookingRefund.mapFromBookingList(booking);

    dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result === "refund") {
          this.getBookings();
        }
      }
    });
  }

  sortData(sort: Sort) {
    this.filter.sortDirection = sort.direction;
    this.filter.sortColumn = sort.active;
    this.getBookings();
  }

  resetFilter() {
    this.filter.page = 1;
    this.filter.text = '';
    this.filter.pageSize = 10;
  }

  openQuickview(booking: any) {
    const dialogRef = this.matDialog.open(BookingQuickviewModalComponent, {
      width: '600px'
    });
    dialogRef.componentInstance.booking = booking;
  }

  /**
   * Formats a date in the user's timezone
   * @param date - The UTC date to format
   * @param format - The moment format string
   * @returns Formatted date string
   */
  formatInUserTimezone(date: Date, format: string): string {
    return moment.utc(date).tz(this.userTimezone).format(format);
  }
}
